import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { ApiService } from '@services/api.service';
import { ManagementSalesTaxesModel, ManagementSalesTaxesUpdateModel } from '@data-layer/models/management';
import { PaginatedResultModel } from '@data-layer/models/common';
import { SalesTaxesSearchModel } from '@app/modules/sales-taxes-management/models';

@Injectable({
  providedIn: 'root',
})
export class SalesTaxesManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(params?: SalesTaxesSearchModel, isShowLoader: boolean = true): Observable<PaginatedResultModel<ManagementSalesTaxesModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementSalesTaxesModel>>(
      `${environment.url.prefixCustoms}v2/management/sales-taxes`,
      { params },
      { isShowLoader },
    );
  }

  public get(id: ManagementSalesTaxesModel['id'], isShowLoader: boolean = true): Observable<ManagementSalesTaxesModel> {
    return this.apiService.get<ManagementSalesTaxesModel>(`${environment.url.prefixCustoms}v2/management/sales-taxes/${id}`, null, {
      isShowLoader,
    });
  }

  public update(
    id: ManagementSalesTaxesModel['id'],
    model: ManagementSalesTaxesUpdateModel,
    isShowLoader: boolean = true,
  ): Observable<any> {
    return this.apiService.put<any>(`${environment.url.prefixCustoms}v2/management/sales-taxes/${id}`, model, null, {
      isShowLoader,
    });
  }

  public active(id: ManagementSalesTaxesModel['id'], activated: boolean, isShowLoader: boolean = true): Observable<any> {
    return this.apiService.post(`${environment.url.prefixCustoms}v2/management/sales-taxes/${id}/active`, activated, null, {
      isShowLoader,
    });
  }
}
